import type { SetupContext } from 'vue'
import type { IToolingBaseComposableDataItem } from '../use-tooling-base/types'
import type {
  IToolingListComposable,
  IToolingListComposableProps,
  IToolingListComposableViewData,
} from './types'
import { useToolingPagination } from '../use-tooling-pagination'
import { useToolingSorting } from '../use-tooling-sorting'
import { computedFn } from './computed'
import { dataFn } from './data'
import { methodsFn } from './methods'

export const useToolingList = <DataItemType extends IToolingBaseComposableDataItem>(
  props: IToolingListComposableProps,
  ctx: SetupContext,
  viewData: IToolingListComposableViewData,
): IToolingListComposable<DataItemType> => {
  const data = dataFn<DataItemType>(props, ctx, viewData)

  const computed = computedFn<DataItemType>(viewData)

  const toolingPagination = useToolingPagination({
    itemsPerPageOptions: viewData.itemsPerPageOptions,
  })

  const toolingSorting = useToolingSorting({
    defaultSortValue: viewData.defaultSorting,
  })

  const methods = methodsFn<DataItemType>(props, ctx, {
    ...data,
    ...toolingPagination,
    ...toolingSorting,
    ...viewData,
    ...computed,
  })

  return {
    ...toolingPagination,
    ...toolingSorting,
    ...data,
    ...computed,
    ...methods,
  }
}

export * from './types'
